import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, effect, inject, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { filter, Subscription } from 'rxjs';
import { AppNavigationService } from './app-navigation.service';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [CommonModule, BreadcrumbModule],
  template: `
    @if (breadcrumbItems().length) {
      <p-breadcrumb class="page-breadcrumb" [model]="breadcrumbItems()" [home]="homeBreadcrumb"></p-breadcrumb>
    }
  `,
  styles: [`
    :host {
      display: block;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppBreadcrumbComponent implements OnInit, OnDestroy {
  private readonly router = inject(Router);
  private readonly appNavigation = inject(AppNavigationService);
  private navigationSubscription?: Subscription;
  private readonly currentUrl = signal(this.router.url);

  readonly homeBreadcrumb: MenuItem = { icon: 'pi pi-home', routerLink: '/' };
  readonly breadcrumbItems = signal<MenuItem[]>([]);

  constructor() {
    effect(() => {
      this.breadcrumbItems.set(this.appNavigation.resolveBreadcrumbs(this.currentUrl()));
    });
  }

  ngOnInit(): void {
    this.navigationSubscription = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(event => this.currentUrl.set(event.urlAfterRedirects ?? this.router.url));
  }

  ngOnDestroy(): void {
    this.navigationSubscription?.unsubscribe();
  }
}
